import { WHY_CHOOSE_CONSTANTS } from "./constants";
import CardsList from "@/components/cardsList";

const WhyChooseComponent = () => {
  return (
    <CardsList
      columns={{ base: 1, sm: 2 }}
      desc={WHY_CHOOSE_CONSTANTS.desc}
      title={WHY_CHOOSE_CONSTANTS.title}
      list={WHY_CHOOSE_CONSTANTS.list}
      spacing={{ base: 8, md: 16 }}
    />
  );
};

export default WhyChooseComponent;
